import request from '@/utils/request'

export function listOnRoad(params) {
  return request({
    baseURL: process.env.VUE_APP_API,
    url: '/verification/listOnRoad',
    method: 'get',
    params
  })
}

export function createOnRoad(data) {
  return request({
    baseURL: process.env.VUE_APP_API,
    url: '/verification/createOnRoad',
    method: 'post',
    data
  })
}

// 详情
export function detailOnRoad(id) {
  return request({
    baseURL: process.env.VUE_APP_API,
    url: `/verification/detailOnRoad/${id}`,
    method: 'get'
  })
}

// 更新
export function updateOnRoad(data) {
  return request({
    baseURL: process.env.VUE_APP_API,
    url: `/verification/updateOnRoad`,
    method: 'put',
    data
  })
}

// 删除
export function deleteOnRoad(id) {
  return request({
    baseURL: process.env.VUE_APP_API,
    url: `/verification/deleteOnRoad/${id}`,
    method: 'delete'
  })
}

// 审核
export function checkOnRoad(data) {
  return request({
    baseURL: process.env.VUE_APP_API,
    url: '/verification/checkOnRoad',
    method: 'put',
    data
  })
}

// 非道路列表
export function listOffRoad(params) {
  return request({
    baseURL: process.env.VUE_APP_API,
    url: '/verification/listOffRoad',
    method: 'get',
    params
  })
}

// 新增非道路
export function createOffRoad(data) {
  return request({
    baseURL: process.env.VUE_APP_API,
    url: '/verification/createOffRoad',
    method: 'post',
    data
  })
}

// 非道路详情
export function detailOffRoad(id) {
  return request({
    baseURL: process.env.VUE_APP_API,
    url: `/verification/detailOffRoad/${id}`,
    method: 'get'
  })
}

// 更新非道路
export function updateOffRoad(data) {
  return request({
    baseURL: process.env.VUE_APP_API,
    url: `/verification/updateOffRoad`,
    method: 'put',
    data
  })
}

// 删除非道路
export function deleteOffRoad(id) {
  return request({
    baseURL: process.env.VUE_APP_API,
    url: `/verification/deleteOffRoad/${id}`,
    method: 'delete'
  })
}

// 审核
export function checkOffRoad(data) {
  return request({
    baseURL: process.env.VUE_APP_API,
    url: '/verification/checkOffRoad',
    method: 'put',
    data
  })
}
